import { useQuery } from '@tanstack/react-query';
import { BotAPIClient } from '@/api/client';
import { useRef } from 'react';
export function useDashboardState(version, refreshInterval, isPaused) {
    const clientRef = useRef(null);
    if (!clientRef.current || clientRef.current.getVersion() !== version) {
        clientRef.current = new BotAPIClient(version);
    }
    return useQuery({
        queryKey: ['dashboardState', version],
        queryFn: async () => {
            const response = await clientRef.current.getState();
            if ('error' in response) {
                throw new Error(response.error);
            }
            return response;
        },
        refetchInterval: isPaused ? false : refreshInterval,
        placeholderData: (prev) => prev,
        staleTime: refreshInterval - 5000,
    });
}
//# sourceMappingURL=useDashboardState.js.map